import firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"

// Firestore configs
const firebaseConfig =
  process.env.VUE_APP_FIRE_ENV === "production" ||
  process.env.VUE_APP_FIRE_ENV === "prod-eu"
    ? {
        apiKey: "AIzaSyAe4gcijUGqxc9-wdgXiKiNsI-jrSaJngc",
        authDomain: "releai-bot-prod.firebaseapp.com",
        databaseURL: "https://releai-bot-prod.firebaseio.com",
        projectId: "releai-bot-prod",
        storageBucket: "releai-bot-prod.appspot.com",
        messagingSenderId: "245159449853",
        appId: "1:245159449853:web:52c86ddedcce0506d55a94",
        measurementId: "G-RRC43QGH19"
      }
    : {
        apiKey: "AIzaSyBCeko2MV34S0ejfd-bKFhhfTqFXv888J8",
        authDomain: "cqt-mvp.firebaseapp.com",
        databaseURL: "https://cqt-mvp-default-rtdb.firebaseio.com",
        projectId: "cqt-mvp",
        storageBucket: "cqt-mvp.appspot.com",
        messagingSenderId: "688721672519",
        appId: "1:688721672519:web:1789bd5bf41445d34e3462"
      }

// {
//     apiKey: "AIzaSyDboEb1ProZziABWjY4howdsc3n4KbX7hg",
//     authDomain: "releai-bot-dev.firebaseapp.com",
//     databaseURL: "https://releai-bot-dev.firebaseio.com",
//     projectId: "releai-bot-dev",
//     storageBucket: "releai-bot-dev.appspot.com",
//     messagingSenderId: "173721316690",
//     appId: "1:173721316690:web:e053c9a3d17c02248cde8b"
//   }

// Get a Firestore instance
export const db = firebase.initializeApp(firebaseConfig).firestore()

// Export types that exists in Firestore
const { TimeStamp } = firebase.firestore
export { TimeStamp }
